import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { Navigation, Loader2 } from "lucide-react";

/**
 * Shows distance + ETA for a driver between origin and destination.
 * Uses Google Distance Matrix via /api/maps/distance.
 *
 * Props: origin (string), destination (string)
 */
export default function DistanceBadge({ origin, destination }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!origin || !destination) { setLoading(false); return; }
    let alive = true;
    axios.get(`${API}/maps/distance`, { params: { origin, destination } })
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [origin, destination]);

  if (loading) return <span className="inline-flex items-center gap-1 text-xs text-slate-400"><Loader2 size={10} className="animate-spin" /> …</span>;
  if (!data) return null;
  return (
    <span className="inline-flex items-center gap-1 text-xs bg-blue-500/15 text-blue-300 px-2 py-1 rounded-full" data-testid="distance-badge">
      <Navigation size={11} />
      {data.distance_text} · {data.duration_text}
    </span>
  );
}
